// Header.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from './LanguageContext';
import { COUNTRIES } from './config';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { country } = useLanguage();
  const countryConfig = COUNTRIES[country];
  const isSettings = location.pathname === '/settings';
  const isAccount = location.pathname === '/account';
  const isCompose = location.pathname === '/compose';
  const isPrivacy = location.pathname === '/privacy';
  const showBackButton = isSettings || isAccount || isCompose || isPrivacy;

  return (
    <>
      {/* Skip to main content link for keyboard users */}
      <a href="#main-content" className="skip-to-main">
        Skip to main content
      </a>
      
      <header role="banner">
        <div className="header-content">
          {showBackButton ? (
            <button 
              className="back-button"
              onClick={() => navigate('/')}
              aria-label="Go back to home"
            >
              <span aria-hidden="true">←</span>
            </button>
          ) : (
            <button 
              className="country-flag-button"
              onClick={() => navigate('/settings')}
              aria-label={`Current country: ${countryConfig.name}. Click to change settings.`}
            >
              <span aria-hidden="true">{countryConfig.flag}</span>
            </button>
          )}

          <h1 
            onClick={() => navigate('/')}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && navigate('/')}
            aria-label="Govstr - Go to home"
          >
            Govstr
          </h1>
          
          {!isSettings ? (
            <button 
              className="settings-button"
              onClick={() => navigate('/settings')}
              aria-label="Open settings"
            >
              <span aria-hidden="true">⚙️</span>
            </button>
          ) : (
            <div className="header-spacer" aria-hidden="true" />
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
